import { render } from "./ScaleSelectorWidget.vue?vue&type=template&id=1ed04880"
import script from "./ScaleSelectorWidget.vue?vue&type=script&lang=js"
export * from "./ScaleSelectorWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__